// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"f86061c1","560":"a5110172","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};